webpackJsonp([218581296251300],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/shop-merino-round-cushion.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"path": "/shop/merino-round-cushion/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---shop-merino-round-cushion-95b01b1033e7a3ddd9b2.js